<div class="research-chart-component">
  <div id="researchChart" *ngIf="dataSet">
    <div class="chart-settings">
      <div class="display-section">
        <div *ngIf="displayDataSet">
          <span
            class="line-item"
            [title]="displayData.lineItemName"
            [innerHtml]="displayData.lineItemName | textEllipsis: 15"
          ></span>
          <span class="period">{{ displayData.period }}</span>
          <span class="magnitude" *ngIf="displayData.magnitude"
            >&nbsp;(in {{ displayData.magnitude }})</span
          >
          <div
            class="standard-deviation"
            *ngIf="selectedValue === 'distribution-analysis'"
          >
            <span *ngIf="displayData.consensusValue !== ''"
              >Consensus:&nbsp;{{ displayData.consensusValue }}</span
            >
            <span *ngIf="displayData.stdDev !== ''" class="std"
              >Standard Deviation:&nbsp; {{ displayData.stdDev }}</span
            >
          </div>
        </div>
      </div>
      <div class="options-section">
        <app-multi-select-dropdown
          [data]="defaultData.revisionSourceList"
          [title]="'charts'"
          (callback)="revisionSourceChange($event)"
          *ngIf="defaultData.showRevisionSourceList"
        >
        </app-multi-select-dropdown>
        <span class="chart-type-select">
          <nz-select
            [(ngModel)]="selectedValue"
            nzPlaceHolder="Choose"
            (ngModelChange)="onChartTypeChange()"
            [nzDropdownClassName]="'chart-type-dropdown'"
            id="selectChart"
          >
            <nz-option-group nzLabel="Distribution" *ngIf="showDistribution">
              <nz-option
                nzValue="distribution-analysis"
                *ngIf="defaultData.cut !== 'SCH'"
                nzLabel="Analysis"
              >
              </nz-option>
            </nz-option-group>
            <nz-option-group nzLabel="Trend" *ngIf="showForRollingPeriods">
              <nz-option nzValue="trend-bar" nzLabel="Bar Chart"></nz-option>
            </nz-option-group>
            <nz-option-group nzLabel="Revision by sources" *ngIf="showRevision">
              <nz-option
                nzValue="revision-daily"
                nzLabel="Daily - 1 year"
                *ngIf="showForRollingPeriods"
              ></nz-option>
              <nz-option
                nzValue="revision-monthly"
                nzLabel="Monthly - 2 year"
              ></nz-option>
            </nz-option-group>
          </nz-select>
        </span>
        <label
          *ngIf="
            hasAccessToStockPrice &&
            (selectedValue === 'revision-daily' ||
              selectedValue === 'revision-monthly')
          "
          nz-checkbox
          class="stock-price-label"
          [(ngModel)]="isStockPriceChecked"
          [ngClass]="{ 'ch-pop-checkbox--active': isStockPriceChecked }"
          >Stock Price (EOD)</label
        >
      </div>
    </div>
    <div class="research-carousel-holder" (click)="setFocus($event)">
      <va-icon
        size="small"
        name="less-than"
        class="leftArrow"
        (click)="prevChart()"
      ></va-icon>

      <nz-carousel
        [nzEffect]="effect"
        [nzEnableSwipe]="false"
        *ngIf="dataSet"
        (nzAfterChange)="carouselChange($event)"
      >
        <div nz-carousel-content *ngFor="let index of chartList">
          <div class="chart-holder" *ngIf="index === selectedValue">
            <app-chart-plotter
              [(dataToUse)]="dataToUse"
              [chartType]="selectedValue"
              [pageName]="'addin-charts'"
              [chartTypeDisplay]="chartSubTypeDisplay"
              (chartDataSet)="setDisplayData($event)"
              (addinExportCalled)="exportAddinCallback($event)"
              [isRevisionStockPriceSelected]="isStockPriceChecked"
              (chartStockPriceDataChange)="setPriceStockData($event)"
              *ngIf="dataSet"
            ></app-chart-plotter>
          </div>
        </div>
      </nz-carousel>
      <va-icon
        size="small"
        name="greater-than"
        class="rightArrow"
        (click)="nextChart()"
      ></va-icon>
    </div>
  </div>
</div>

<app-chart-popup
  [chartType]="chartPopupType"
  [dataToUse]="chartPopupDataToUse"
  (addinExport)="exportAddinCallback($event)"
  [beginningStateReferrer]="beginningStateReferrer"
  [closeFeature]="feature"
></app-chart-popup>
